import(/* webpackMode: "eager" */ "/var/www/Fixr/frontend/app/privacy/page.tsx");
